import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import i18nService from './services/core/i18n/i18n';
import { buildYupLocale } from './yupLocale';

const INIT_OPTIONS = {
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json'
  },
  resources: {},
  fallbackLng: 'en_US',
  lng: 'en_US',
  debug: false,
  ns: ['translations'],
  defaultNS: 'translations',
  keySeparator: false,
  interpolation: {
    escapeValue: false
  },
  react: {
    useSuspense: true
  }
} as any;

i18n.use(LanguageDetector).use(initReactI18next);

i18nService.getPublicValues().subscribe(translations => {
  translations.forEach(translation => {
    if (!INIT_OPTIONS.resources[translation.languageCode]) {
      INIT_OPTIONS.resources[translation.languageCode] = {
        translations: {}
      };
    }
    INIT_OPTIONS.resources[translation.languageCode].translations[translation.keyName] = translation.value;
  });

  const currentLanguage = localStorage.getItem('i18nextLng') ?? 'en_US';
  i18n.init(INIT_OPTIONS, buildYupLocale).then(() => {
    i18n.changeLanguage(currentLanguage);
    buildYupLocale(null, i18n.t);
  });
});

export default i18n;
